/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DashboardWallboardEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const dashboardWallboardEntryPoint: EntryPoint<DashboardWallboardEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<DashboardWallboardEntryPointComponent>(
			/* webpackChunkName: "dashboard-wallboard-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => {
			return {};
		},
	});
